import React from 'react';
import classNames from 'classnames';
import { TickThickIcon } from '../../LegacyIcons';

const THEME_CENTER = 'center';

const RadioButton = ({
  id,
  children,
  theme,
  checked = false,
  onChange = () => {},
  ...props
}) => {
  const classList = classNames('c-checkbox-button', {
    'c-checkbox-button--align-center': theme === THEME_CENTER,
  });

  return (
    <span className={classList}>
      <input
        {...props}
        id={id}
        className="c-checkbox-button__input"
        checked={checked ? 'checked' : ''}
        onChange={onChange}
        type="radio"
      />
      <label className="c-checkbox-button__label" htmlFor={id}>
        <span className="c-checkbox-button__icon-container">
          <TickThickIcon className="c-checkbox-button__icon" />
        </span>
        <span className="c-checkbox-button__label-text">{children}</span>
      </label>
    </span>
  );
};

export default RadioButton;
